export default __webpack_public_path__ + "static/media/youtube.318bb8b3.svg";